import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AdminDashboardContent from './AdminDashboardContent';
import { ADMIN_EMAILS } from './AdminCommon';
import AdminLogin from './AdminLogin';
import AdminDashboardNavbar from './AdminDashboardNavbar';

function AdminDashboard() {

    const { currentUser } = useAuth();
    
    function isAdmin(email) {
        for (let i = 0; i < ADMIN_EMAILS.length; i++) {
            if (email === ADMIN_EMAILS[i]) {
                return true;
            }
        }
        return false;
    }

    return (
        <div>
            { currentUser ? <AdminDashboardNavbar /> : null }
            <div style={{ height: '80px' }}></div>
            {
                currentUser && currentUser.email && isAdmin(currentUser.email) ?
                    <AdminDashboardContent /> :
                    <AdminLogin />
            }
        </div>
    );
}

export default AdminDashboard;
